import styled, { css } from 'styled-components'

interface ListVideoProps {
  showList?: boolean
}

export const Container = styled.div`
  width: 100%;
  height: auto;
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem;
  display: flex;
  flex-direction: column !important;

  @media only screen and (min-width: 1100px) {
    flex-direction: row !important;
    gap: 27px;
    padding: 2rem;
  }
`

export const Wrapper = styled.div`
  flex-direction: row;
  width: 350px;

  @media only screen and (min-width: 1100px) {
    width: 850px;
  }
`

export const VideosList = styled.div<ListVideoProps>`
  display: flex;
  flex-direction: column;
  color: #a7a7a7;
  font-weight: 400;
  width: 350px;
  height: 510.682px;
  overflow-y: scroll;
  gap: 15px;

  .nextVideo {
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
  }

  ${(props) =>
    !props.showList &&
    css`
      display: none;
    `}

  img {
    opacity: 0.4;
    transition: all 0.6s ease-out;
    border: solid 3px transparent;
  }

  .current {
    color: #fff;
    font-weight: 700;

    img {
      opacity: 1;
      border: solid 3px #ff6600;
    }
  }

  @media only screen and (min-width: 1100px) {
    width: 427px;
  }
`

export const ImageVideoList = styled.div`
  display: flex;

  .video {
    position: relative;
  }

  .video .video-duration {
    position: absolute;
    bottom: 9px;
    right: 5px;
    border-radius: 3px;
    background-color: rgba(0, 0, 0, 0.7);
    color: #fff;
    padding: 3px 6px;
    font-size: 12px;
  }
  .selectedVideo {
    border-radius: 8.443px;
    border: 1.809px solid #f60;
  }

  .video {
    position: relative;
  }

  .watchedText {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 14px;

    svg {
      margin-right: 0.1rem;
      color: #14cbbc;
    }
  }

  img {
    border-radius: 10px;
  }
`

export const Video = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  cursor: pointer;
  margin: 5px 0px;
`

export const NameVideo = styled.div`
  display: flex;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  max-height: 5 * 1.2em;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;

  .selectedText {
    font-weight: 700;
  }
`

export const ContainerFrame = styled.div``

export const ContainerTitle = styled.div`
  display: flex;
  padding-top: 1rem;
  align-items: flex-start;
  justify-content: space-between;
  color: #fff;
  font-weight: 700;

  h3 {
    margin: 0 1rem 0 0;
  }

  svg {
    margin-right: 0.3rem;
    cursor: pointer;
  }

  div {
    display: flex;
    align-items: center;
    margin-left: 8px;
  }
`
